import { useTranslation } from 'react-i18next';
import { SecretRevealDialog } from './secret-reveal-dialog';

interface WebhookSecretRevealDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  /** The click-webhook secret cleartext — sourced from the mutation response, never a GET. */
  secretCleartext: string;
  onConfirm: () => void;
}

/**
 * Click-Webhook-Secret-Reveal-Modal (Spec 505 Inc 2b/3, D-Reveal-Reuse). Thin wrapper over the
 * generic {@link SecretRevealDialog} injecting the `webhookReveal.*` copy from the `payment-link`
 * namespace. Shown exactly once when the Click-Webhook is first activated; strictly sequential to
 * the Salt reveal (never both cleartexts on screen at once). Cleartext lives only in caller state.
 */
export function WebhookSecretRevealDialog({
  open,
  onOpenChange,
  secretCleartext,
  onConfirm,
}: WebhookSecretRevealDialogProps) {
  const { t } = useTranslation('payment-link');
  return (
    <SecretRevealDialog
      open={open}
      onOpenChange={onOpenChange}
      secret={secretCleartext}
      onConfirm={onConfirm}
      labels={{
        title: t('webhookReveal.title'),
        warning: t('webhookReveal.warning'),
        hint: t('webhookReveal.hint'),
        copy: t('webhookReveal.copy'),
        copied: t('webhookReveal.copied'),
        confirm: t('webhookReveal.confirm'),
      }}
    />
  );
}
